export default __webpack_public_path__ + "static/logo_ocna_ambulancia-3b8ba2a7d15a416dae61e4032000b8fb.svg";